var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 125,
    viewBox: "0 0 123 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    "transform-origin": "50% 50%",
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 60 70",
    to: "360 60 70",
    dur: "10s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5279 37.1495C30.4503 40.8917 24.82 46.6481 22.6137 53.3719C18.3476 48.5037 16.2292 42.5077 23.442 37.2318C30.8833 31.7895 35.6213 33.7215 38.5285 37.1501L38.5279 37.1495Z",
    fill: "#5B00AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6313 46.0997L34.9257 62.9015C34.9257 62.9015 27.412 58.8488 22.6136 53.3719C24.82 46.6481 30.4503 40.8917 38.5279 37.1495C41.6092 40.7845 42.6313 46.0997 42.6313 46.0997Z",
    fill: "#0088D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7425 64.6576C94.1923 67.3579 90.4357 74.8041 90.4357 74.8041C90.4357 74.8041 91.675 93.235 77.7104 99.1941C70.637 102.213 59.3196 97.7855 42.6667 94.8021C36.2667 93.6547 31.3116 104.662 25.2429 97.2431C19.7023 90.4746 26.4175 81.243 22.3063 65.4385C21.2118 61.2355 21.3727 57.1517 22.6137 53.372C24.82 46.6481 30.4503 40.8918 38.528 37.1495C43.9801 34.6228 50.5505 33.0127 57.9368 32.6461C99.8321 30.5604 98.188 47.7211 94.7425 64.6576Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0152 52.7556C45.0152 52.7556 57.9361 32.658 70.2703 51.4537C77.1434 61.9281 66.4725 77.0323 79.2761 77.1455C88.1731 77.2242 82.6403 97.3301 74.7732 101.558C62.7213 108.035 25.0466 107.779 24.2637 90.7499C23.9814 84.6085 29.5495 79.8774 26.0257 66.6092C23.6268 57.5767 32.8587 50.4225 45.0158 52.7556H45.0152Z",
    fill: "#AF64FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4962 66.813L86.3934 65.2006C86.5405 65.1005 101.104 55.0815 101.874 44.6786C102.14 41.0908 100.691 37.8124 97.5684 34.9345C93.9381 31.5893 90.7641 30.3589 88.1356 31.2757C82.2355 33.3346 80.3546 45.2259 80.3366 45.3463L78.4012 45.0524C78.4832 44.5153 80.4897 31.8766 87.489 29.4344C90.8556 28.2595 94.6941 29.6281 98.898 33.5021C102.482 36.8044 104.14 40.614 103.827 44.8259C102.983 56.1676 88.1284 66.3832 87.4968 66.813H87.4962Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3784 47.06C79.3784 47.06 83.5357 20.92 98.0863 34.3283C112.638 47.7366 85.5117 66.1955 85.5117 66.1955C85.5117 66.1955 86.7677 61.6623 84.2109 54.5278C82.5381 49.8604 79.3784 47.06 79.3784 47.06Z",
    fill: "#5B00AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.534 57.5421C78.0609 57.5421 77.6153 57.2554 77.4365 56.7887C77.205 56.1848 77.5089 55.5083 78.1147 55.277C89.8358 50.8129 87.8999 40.8619 87.8113 40.4405C87.6792 39.8092 88.0841 39.1881 88.7174 39.0546C89.3502 38.9211 89.9728 39.3216 90.1086 39.9523C90.1361 40.0793 90.7658 43.102 89.6965 46.7745C88.7103 50.1602 86.0458 54.7626 78.9526 57.464C78.8145 57.5165 78.6727 57.5415 78.5334 57.5415L78.534 57.5421Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8104 19C67.8104 19 36.8348 37.568 47.1008 38.2517C57.3668 38.9354 67.8104 34.8052 67.8104 34.8052C67.8104 34.8052 61.1873 27.8351 67.8104 19Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3636 26.9732C73.3636 26.9732 48.6606 39.0171 56.3172 40.1604C63.9738 41.3036 72.1375 38.843 72.1375 38.843C72.1375 38.843 67.7046 33.2023 73.3636 26.9738V26.9732Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9568_4941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2094 89.516C24.2321 90.4912 26.4438 93.1354 32.2864 91.5844C35.3922 90.76 37.9819 87.7635 41.7462 87.3874C43.9477 87.1675 45.282 88.8693 51.5995 88.4627C57.246 88.0991 59.8219 85.1759 61.0964 82.4041C63.2501 77.7213 24.0951 84.5506 24.2099 89.516H24.2094Z",
    fill: "#AF64FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.9203 55.5507C33.461 55.4797 33.9789 55.7939 34.1596 56.3071C34.4323 57.0838 33.2786 57.8319 32.4975 58.0983L27.7841 60.0565C27.7841 60.0565 28.8044 56.0907 32.9209 55.5507H32.9203Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7257 49.0366C53.4206 50.0899 54.1174 51.1688 55.2053 51.3291L67.3265 53.1132C67.3265 53.1132 64.5132 46.9956 56.3034 47.0743C55.1048 47.0856 54.0582 47.8891 53.7263 49.0366H53.7257Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3398 63.6952C65.7047 58.4685 62.9379 54.019 59.16 53.757C55.3822 53.4951 52.0238 57.5198 51.6589 62.7465C51.2941 67.9732 54.0609 72.4226 57.8387 72.6846C61.6166 72.9466 64.9749 68.9219 65.3398 63.6952Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3012 63.5537C63.5574 59.8847 61.6152 56.7613 58.9633 56.5774C56.3113 56.3935 53.9539 59.2188 53.6978 62.8878C53.4416 66.5568 55.3838 69.6803 58.0357 69.8642C60.6876 70.0481 63.0451 67.2228 63.3012 63.5537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3954 62.5417C62.4837 61.276 60.837 60.1308 58.7172 59.9838C56.5975 59.8368 54.8074 60.7437 54.7191 62.0094C54.6307 63.2751 56.2775 64.4203 58.3972 64.5673C60.517 64.7143 62.307 63.8074 62.3954 62.5417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5366 62.6518C57.0261 62.6518 57.423 62.2563 57.423 61.7684C57.423 61.2805 57.0261 60.885 56.5366 60.885C56.0471 60.885 55.6503 61.2805 55.6503 61.7684C55.6503 62.2563 56.0471 62.6518 56.5366 62.6518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3057 63.5292C63.5611 59.8752 61.6179 56.7636 58.9661 56.58C56.3142 56.3958 53.9572 59.2088 53.7018 62.8627C53.7018 62.8627 55.8429 61.3618 58.6443 61.4816C61.0773 61.5853 63.3057 63.5292 63.3057 63.5292Z",
    fill: "#AF64FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.213 76.4014C39.3848 75.5039 40.8648 70.9457 39.5187 66.2203C38.1726 61.495 34.5102 58.3919 31.3384 59.2894C28.1666 60.1869 26.6866 64.7451 28.0326 69.4705C29.3787 74.1958 33.0412 77.2989 36.213 76.4014Z",
    fill: "#9500FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3312 73.3061C37.3555 72.7333 38.3002 69.824 37.4411 66.8082C36.582 63.7923 34.2444 61.8119 32.22 62.3847C30.1957 62.9576 29.251 65.8668 30.1101 68.8826C30.9692 71.8985 33.3068 73.8789 35.3312 73.3061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0562 68.6727C35.542 68.2522 36.5146 67.0973 36.2285 66.0931C35.9424 65.0889 34.506 64.6156 33.0202 65.036C31.5344 65.4565 30.5619 66.6114 30.8479 67.6156C31.134 68.6198 32.5704 69.0931 34.0562 68.6727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5522 67.7386C32.9649 67.6218 33.2103 67.2139 33.1003 66.8275C32.9902 66.4412 32.5664 66.2226 32.1536 66.3394C31.7409 66.4562 31.4955 66.8641 31.6055 67.2505C31.7156 67.6368 32.1394 67.8554 32.5522 67.7386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4442 66.8052C36.5848 63.7897 34.2469 61.8089 32.223 62.3817C30.1985 62.9546 29.2541 65.864 30.1136 68.8796C30.1136 68.8796 31.7714 66.6819 33.4054 66.3093C35.5842 65.8122 37.4442 66.8047 37.4442 66.8047V66.8052Z",
    fill: "#AF64FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1084 82.9601C43.5242 82.5381 45.3016 81.1669 45.0783 79.8974C44.8551 78.6279 42.7158 77.9408 40.3001 78.3628C37.8844 78.7847 36.107 80.1559 36.3302 81.4254C36.5534 82.6949 38.6927 83.382 41.1084 82.9601Z",
    fill: "#5B00AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8669 87.6402C39.538 86.5869 39.4937 85.3244 39.6911 84.4511C39.901 83.5212 40.4136 82.8459 40.4351 82.8173L40.7204 83.0342C40.7156 83.0408 40.2294 83.684 40.0386 84.5399C39.7892 85.6606 40.1433 86.6095 41.09 87.36L40.8669 87.6402Z",
    fill: "#5B00AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9568_4941",
    x: 24.2094,
    y: 80.8364,
    width: 37.9728,
    height: 12.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9568_4941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9568_4941",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.3c46bb28.svg";
export { ForwardRef as ReactComponent };